// Production environment configuration
// API_URL is injected during build by AWS Amplify
// Update this value or set API_URL environment variable in Amplify Console
export const environment = {
  production: true,
  // Backend API is hosted at api.botmaa.in
  apiUrl: 'https://api.botmaa.in/api/v1',
  googleClientId: '562441233562-6e4po4mtcus4m4bs9otv619jc3ukj7t7.apps.googleusercontent.com',
  googleRedirectUri: 'https://botmaa.in/auth/callback',
  razorpayKey: 'rzp_test_RmbjIicvlVl4Uu', // Add production key when available
  signupPasswordEncryptionSecret: 'change-this-shared-signup-secret',
  /**
   * Firebase Web SDK (FCM Step 1) — production project.
   * Prefer injecting these via Amplify/CI environment variables at build time.
   */
  firebase:  {
    apiKey: "AIzaSyCO9saAatk3Chkt_Z8TsTl-3lC9I8YKfQ0",
    authDomain: "botmaa-50f5a.firebaseapp.com",
    projectId: "botmaa-50f5a",
    storageBucket: "botmaa-50f5a.firebasestorage.app",
    messagingSenderId: "562441233562",
    appId: "1:562441233562:web:f6788c419a69f8a5d3ab23",
    vapidKey: 'BJKOKXiOt1eiVy4c4l2BjdLCnfVSfHAYmn7LW6Nz3kBLRKcf7F3dbVAaqLibdZGo52pn_doYnhIy1LbpDbx-daE',
  }
};
